import React, { useRef, useState, useEffect, Fragment } from 'react';

//Headlessui for MODAL
import { Dialog, Transition } from '@headlessui/react'

//Animation
import { useAutoAnimate } from '@formkit/auto-animate/react'

//Skeleton
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//E-Posta Check
import emailValidator from 'email-validator'

//ICONS
import { BsCheck2Circle, BsXLg, BsPencil, BsFillExclamationTriangleFill, BsPersonLock, BsPersonCheck   } from "react-icons/bs";

//APIS
import { danismanGET, danismanCreate, danismanUpdate } from '../../../apis/danisman';

//HELPERS
import upperCase from '../../../helpers/upperCase';

const DanismanTanimlari = () => {

    const [animationParent] = useAutoAnimate()
    const [loading, setLoading] = useState(false) // Skleton için kullanılacak
    const [formDurum, setFormDurum] = useState(false) // false yeni kayıt true düzenleme anabilim/anasanat dalı formu
    const [openModal, setOpenModal] = useState(false)




    //REFS
    const unvanRef = useRef()
    const adRef = useRef()
    const epostaRef = useRef()
    const telefonRef = useRef()



    //STATES FORM 1
    const [selectedDanismanId, setSelectedDanismanId] = useState(0)
    const [unvan, setUnvan] = useState("")
    const [ad, setAd] = useState("")
    const [eposta, setEposta] = useState("")
    const [telefon, setTelefon] = useState("")




    //LIST STATES
    const [danismanLIST, setDanismanLIST] = useState([])
    const [filteredDanisman, setFilteredDanisman] = useState([])

    //HANDLE FUNCTIONS
    const handleFormControl = () => {
        if (unvan === "") {
            unvanRef.current.focus()
            return toast.error("Unvan seçiniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }

        if (ad === "") {
            adRef.current.focus()
            return toast.error("Danışman adını giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }

        const emailChecking = emailValidator.validate(eposta)
        if (eposta === "" || emailChecking === false) {
            epostaRef.current.focus()
            return toast.error("Danışman kurumsal e-posta adresini giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }

        if (telefon === "") {
            telefonRef.current.focus()
            return toast.error("Danışman cep telefon numarasını giriniz", {
                position: toast.POSITION.TOP_CENTER
            });
        }

        if (formDurum === false) {
            //yeni kayıt
            handleFormSave()
        } else {
            //düzenleme
            handleFormUpdate()
        }

    }

    const handleFormSave = async () => {
        let data = {
            danismanUnvan: unvan,
            danismanAdSoyad: upperCase(ad.trim()),
            danismanEposta: eposta.trim(),
            danismanCepNo: telefon.trim()
        }

        let dansimanCheck = danismanControl()
        if (dansimanCheck >= 1) {
            toast.error("Girmiş olduğunuz bilgilele daha önce bir danışman eklenmiş", {
                position: toast.POSITION.TOP_CENTER
            });
        } else {
            let result = await danismanCreate(data)
            if (result.status === 200) {
                toast.success("Kayıt yapıldı", {
                    position: toast.POSITION.TOP_CENTER
                });
                getDanismanLIST()
                handleFormClear()
            }
        }
    }

    const handleFormUpdate = async () => {
        let data = {
            danismanUnvan: unvan,
            danismanAdSoyad: upperCase(ad.trim()),
            danismanEposta: eposta.trim(),
            danismanCepNo: upperCase(telefon.trim())
        }
        let dansimanCheck = danismanControl()
        if (dansimanCheck > 1) {
            toast.error("Girmiş olduğunuz bilgilele daha önce bir danışman eklenmiş", {
                position: toast.POSITION.TOP_CENTER
            });
        } else {
            let result = await danismanUpdate(selectedDanismanId, data)
            if (result.status === 200) {
                toast.success("Kayıt güncellendi", {
                    position: toast.POSITION.TOP_CENTER
                });
                getDanismanLIST()
                handleFormClear()
            }
        }

    }

    const handleFormDelete = async (value) => {
        let data = {
            danismanIsDelete: !value.durum
        }

        let result = await danismanUpdate(value.id, data)
        if (result.status === 200) {
            toast.success("Danışman durumu değiştirildi", {
                position: toast.POSITION.TOP_CENTER
            });
            getDanismanLIST()
            handleFormClear()
        } else {
            handleFormClear()
            return toast.error(result.response.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }

    }

    const handleTelefonControl = (e) => {
        const re = /^\d{0,10}$/;
        if (e === "" || re.test(e)) {
            setTelefon(e);
        }
    }

    const handleFilter = (value) => {

        const lowercasedValue = value.toLocaleLowerCase('TR').trim()
        const filteredDanisman = danismanLIST.filter(item => {
            //eslint-disable-next-line
            return Object.keys(item).some(key => {
                if (typeof item[key] === 'string') {
                    return item[key].toString().toLocaleLowerCase('TR').includes(lowercasedValue.toLocaleLowerCase('TR'))
                }
            });
        });
        setFilteredDanisman(filteredDanisman)
    }

    const danismanControl = () => {
        let checkDanisman = danismanLIST.filter(item => item.danismanEposta === eposta || item.danismanCepNo === telefon).length
        return checkDanisman
    }

    const handleFormClear = () => {
        setUnvan("")
        setAd("")
        setEposta("")
        setTelefon("")
        setFormDurum(false)
        setOpenModal(false)
        setSelectedDanismanId(0)
    }


    //API FUNCTIONS
    const getDanismanLIST = async () => {
        setLoading(true)
        let result = await danismanGET()
        //console.log(result.data)
        if (result.status === 200) {
            setDanismanLIST(result.data)
            setFilteredDanisman(result.data)
            setLoading(false)
        }
    }

    useEffect(() => {
        getDanismanLIST()
    }, []);

    return (
        <>
            <ToastContainer />
            <main className='text-slate-500 text-sm transition-all'>
                <div className="py-5">
                    <div className="w-full px-4 sm:px-6 md:px-8">
                        <div className='container mx-auto'>
                            <h1 className='page-title leading-6 font-normal text-lg mb-6 text-slate-500 '>Danışman Tanımları</h1>
                        </div>
                        <div className='container mx-auto space-y-4'>
                            <div className='kapsama relative w-full flex flex-col lg:flex-row gap-4'>

                                {/* ANABİLİM/ANASANAT DALI*/}
                                <div className='max-w-6xl'>
                                    <div className='bg-white rounded-lg p-4 min-h-0'>
                                        <h1 className='text-lg text-slate-950 mb-4'>Yeni Danışman Ekle</h1>
                                        <div className='flex flex-col items-start gap-2 mb-6'>

                                            <div className='w-full flex flex-col md:flex-row gap-2'>
                                                <div className=''>
                                                    <label>Unvan</label>
                                                    <select value={unvan} onChange={(e) => { setUnvan(e.target.value) }} ref={unvanRef} className='sd-form-input' type='text' placeholder='Adı'>
                                                        <option value="">Seçiniz</option>
                                                        <option value="Prof. Dr.">Prof. Dr.</option>
                                                        <option value="Prof.">Prof.</option>
                                                        <option value="Doç. Dr.">Doç. Dr.</option>
                                                        <option value="Doç.">Doç.</option>
                                                        <option value="Dr. Öğretim Üyesi">Dr. Öğretim Üyesi</option>
                                                        <option value="Dr.">Dr.</option>
                                                        <option value="Öğretim Görevlisi">Öğretim Görevlisi</option>
                                                        <option value="Okuman">Okuman</option>
                                                    </select>
                                                </div>
                                                <div className='flex-1'>
                                                    <label>Danışman Adı Soyadı</label>
                                                    <input value={ad} onChange={(e) => { setAd(e.target.value) }} ref={adRef} className='sd-form-input' type='text' placeholder='Adı Soyadı' />
                                                </div>
                                            </div>
                                            <div className='w-full flex flex-col md:flex-row gap-x-2 gap-y-2 items-end'>
                                                <div className='w-full md:flex-1'>
                                                    <label>E-Posta</label>
                                                    <input value={eposta} onChange={(e) => { setEposta(e.target.value) }} ref={epostaRef} className='sd-form-input' type='text' placeholder='@odu.edu.tr' />
                                                </div>
                                                <div className='w-full md:flex-1'>
                                                    <label>Telefon</label>
                                                    <input value={telefon} onChange={(e) => { handleTelefonControl(e.target.value) }} ref={telefonRef} className='sd-form-input' type='text' placeholder='5XX XXX XXXX' />
                                                </div>
                                                <div className='flex gap-3'>
                                                    <div className='text-right'>
                                                        <button
                                                            disabled={unvan !== "" && ad !== "" && eposta !== "" && telefon !== "" ? false : true}
                                                            onClick={() => handleFormControl()}
                                                            className='w-full text-xs h-10 inline-flex items-center gap-x-2 text-white bg-slate-500 disabled:bg-slate-300  hover:bg-slate-500/80 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                            <BsCheck2Circle className='text-lg' />
                                                            {formDurum ? "DÜZENLE" : "KAYDET"}
                                                        </button>
                                                    </div>
                                                    <div className='text-right'>
                                                        <button
                                                            disabled={unvan !== "" && ad !== "" && eposta !== "" && telefon !== "" ? false : true}
                                                            onClick={() => handleFormClear()}
                                                            className='w-full text-xs h-10 inline-flex items-center gap-x-2 text-white bg-red-400 disabled:bg-red-300 hover:bg-red-500 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-red-300 transition-all'>
                                                            <BsXLg className='text-lg' />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h1 className='text-slate-950 mb-4'>Kayıtlı Anabilim/Anasanat Dalları</h1>
                                        <div className='w-full mb-2'>
                                            <input onChange={(e) => handleFilter(e.target.value)} className='sd-form-input' type='text' placeholder='Danışman Ara...' />
                                        </div>
                                        <div className='w-full'>
                                            <ul className='flex flex-col text-xs'>
                                                <div ref={animationParent}>
                                                    {
                                                        loading ? <Skeleton baseColor="#e2e8f0" width="100%" count={3} height={20} /> : (
                                                            filteredDanisman?.length > 0 ? (
                                                                filteredDanisman?.map((item, key) => (
                                                                    <li key={key} className='w-full mb-2 bg-slate-100 hover:bg-slate-200 hover:cursor-pointer rounded-md p-2 flex items-center space-y-1 flex-row md:items-center md:space-x-4'>

                                                                        <div className='flex-1'>{item.danismanUnvan + " " + item.danismanAdSoyad + " " + item.danismanEposta + " " + item.danismanCepNo}</div>

                                                                        <div className='md:text-right space-x-4'>
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    setFormDurum(true)
                                                                                    setSelectedDanismanId(item.danismanId)
                                                                                    setUnvan(item.danismanUnvan)
                                                                                    setAd(item.danismanAdSoyad)
                                                                                    setEposta(item.danismanEposta)
                                                                                    setTelefon(item.danismanCepNo)
                                                                                }}
                                                                                className='text-xs inline-flex items-center gap-x-1 text-white bg-slate-500 border-transparent border hover:bg-slate-500/80 px-2 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                                                <BsPencil />Düzenle
                                                                            </button>
                                                                            {
                                                                                item.danismanIsDelete === true ? (
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            handleFormDelete({id: item.danismanId, durum: item.danismanIsDelete})
                                                                                        }}
                                                                                        className='text-lg inline-flex items-center gap-x-1 text-white bg-red-500 border-transparent border hover:bg-red-500/80 px-2 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-red-300'>
                                                                                        <BsPersonLock/>              
                                                                                    </button>
                                                                                ) : (
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            handleFormDelete({id: item.danismanId, durum: item.danismanIsDelete})
                                                                                        }}
                                                                                        className='text-lg inline-flex items-center gap-x-1 text-white bg-teal-500 border-transparent border hover:bg-teal-500/80 px-2 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-teal-300'>
                                                                                        <BsPersonCheck/>
                                                                                    </button>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </li>
                                                                ))
                                                            ) : (
                                                                <div>Listelenecek kayıt bulunamamıştır.</div>
                                                            )
                                                        )
                                                    }
                                                </div>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
            <Transition.Root show={openModal} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={setOpenModal}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                        <button
                                            type="button"
                                            className="rounded-md bg-white text-gray-400 hover:text-gray-500 "
                                            onClick={() => setOpenModal(false)}
                                        >
                                            <span className="sr-only">Close</span>
                                            <BsXLg className="h-6 w-6" aria-hidden="true" />
                                        </button>
                                    </div>
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <BsFillExclamationTriangleFill className="h-6 w-6 text-red-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                                UYARI!
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <p className="text-sm text-gray-500">
                                                    Seçili Anabilim/Anasanat Dalını Silmek Üzeresiniz. Emin misiniz?
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                        <button
                                            onClick={() => handleFormDelete(false)}
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                        >
                                            Evet
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                            onClick={() => {
                                                setOpenModal(false)
                                                setSelectedDanismanId(0)
                                            }}
                                        >
                                            İptal
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
}

export default DanismanTanimlari;
